export const TERMS_OF_SERVICE_URL = process.env.TERMS_OF_SERVICE_URL
export const PRIVACY_POLICY_URL = process.env.PRIVACY_POLICY_URL
